import { useEffect, useState, useMemo } from "react";
import { App } from "antd";

import { getManagedUnits } from "@/api/my";

export const useManagedUnits = (isAdmins, unit_uuid) => {
  const { message } = App.useApp();

  const [managedUnits, setManagedUnits] = useState([]);
  const [managedUnitsPending, setManagedUnitsPending] = useState(true);

  useEffect(() => {
    if (isAdmins) {
      setManagedUnitsPending(false);
      return;
    }

    const fetchManagedUnits = async () => {
      try {
        setManagedUnitsPending(true);
        const data = await getManagedUnits();

        setManagedUnits(data || []);
      } catch (error) {
        message.open({
          type: "error",
          content: error.message,
          duration: 10,
        });
        setManagedUnits([]);
      } finally {
        setManagedUnitsPending(false);
      }
    };

    fetchManagedUnits();

    // eslint-disable-next-line
  }, [isAdmins]);

  // Добавлять новый спринт могут только админы или менеджеры РГ
  const isCanAddSprint = useMemo(() => {
    if (managedUnitsPending) return false;
    if (isAdmins) return true;

    return unit_uuid
      ? managedUnits.some((unit) => unit.uuid === unit_uuid)
      : managedUnits.length > 0;
  }, [managedUnitsPending, managedUnits, unit_uuid, isAdmins]);

  return {
    managedUnits,
    managedUnitsPending,
    isCanAddSprint,
  };
};
